import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import api from "../lib/api";

export const ServiceStep = ({ selectedServiceId, onSelect }) => {
  const { t, lang } = useLanguage();
  const [services, setServices] = useState(null);

  useEffect(() => {
    api.get("/services").then(({ data }) => setServices(data)).catch(() => setServices([]));
  }, []);

  return (
    <div data-testid="booking-service-step">
      <h2 className="font-serif text-2xl text-white mb-6">{t("booking.selectService")}</h2>
      {services === null && <p className="text-white/50">{t("common.loading")}</p>}
      {services && services.length === 0 && <p className="text-white/60">{t("booking.noServices")}</p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {services && services.map((s) => (
          <button
            key={s.id}
            data-testid={`booking-select-service-${s.id}`}
            onClick={() => onSelect(s)}
            className={`text-left p-5 border rounded-xl transition-colors ${
              selectedServiceId === s.id ? "border-gold bg-gold/5" : "border-white/10 bg-[#141414] hover:border-white/30"
            }`}
          >
            <h3 className="text-white font-medium mb-1">{lang === "nl" ? s.name_nl : s.name_en}</h3>
            <p className="flex items-center gap-1.5 text-white/40 text-xs mb-2"><Clock size={12} /> {s.duration} {t("services.minutesLabel")}</p>
            <span className="text-gold font-serif text-lg">€{s.price % 1 === 0 ? s.price.toFixed(0) : s.price}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
